var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21271 5.05219H11.2097C11.2661 5.05219 11.3202 5.02976 11.3601 4.98984C11.4 4.94992 11.4224 4.89578 11.4224 4.83932V3.06541C11.4224 3.00896 11.4 2.95481 11.3601 2.91489C11.3202 2.87497 11.2661 2.85254 11.2097 2.85254H1.21271C1.18477 2.85254 1.15712 2.85805 1.13131 2.86875C1.1055 2.87944 1.08205 2.89512 1.0623 2.91489C1.04255 2.93466 1.02689 2.95813 1.0162 2.98395C1.00551 3.00978 1 3.03746 1 3.06541V4.83932C1 4.86728 1.00551 4.89496 1.0162 4.92078C1.02689 4.94661 1.04255 4.97007 1.0623 4.98984C1.08205 5.00961 1.1055 5.02529 1.13131 5.03598C1.15712 5.04668 1.18477 5.05219 1.21271 5.05219Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2216 11.5265H2.29402C2.23117 11.5265 2.16893 11.5141 2.11087 11.4901C2.05281 11.466 2.00005 11.4307 1.95561 11.3862C1.91117 11.3418 1.87591 11.289 1.85186 11.2309C1.82781 11.1728 1.81543 11.1105 1.81543 11.0476V5.05176H10.678V6.2048",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32495 5.0525H7.22154V2.71094H5.32495V5.0525Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32078 1.56738C6.55275 1.56734 6.77548 1.66582 6.94104 1.84165C7.10659 2.01747 7.20175 2.25659 7.20605 2.50755V2.89782H5.4519V2.50755C5.4519 2.2582 5.54345 2.01907 5.70639 1.84275C5.86934 1.66643 6.09034 1.56738 6.32078 1.56738Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56663 1C4.7986 0.999957 5.02133 1.09844 5.18689 1.27426C5.35244 1.45009 5.4476 1.6892 5.4519 1.94017V2.89808H4.56663C4.33469 2.89344 4.11371 2.79046 3.95122 2.61132C3.78873 2.43218 3.69771 2.19118 3.69775 1.94017C3.69775 1.69082 3.7893 1.45168 3.95224 1.27537C4.11519 1.09905 4.33619 1 4.56663 1Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45187 2.89764H4.14036C3.79252 2.89764 3.45894 2.74813 3.21299 2.48199C2.96703 2.21585 2.82886 1.85489 2.82886 1.47852",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07468 1C7.84424 1 7.62325 1.09905 7.4603 1.27537C7.29736 1.45168 7.20581 1.69082 7.20581 1.94017V2.89808H8.07468C8.19094 2.89808 8.30606 2.8733 8.41346 2.82516C8.52087 2.77702 8.61845 2.70647 8.70066 2.61752C8.78286 2.52857 8.84807 2.42297 8.89256 2.30675C8.93705 2.19053 8.95995 2.06597 8.95995 1.94017C8.95566 1.6892 8.8605 1.45009 8.69494 1.27426C8.52939 1.09844 8.30666 0.999957 8.07468 1Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20581 2.89764H8.51732C8.86516 2.89764 9.19874 2.74813 9.44469 2.48199C9.69065 2.21585 9.82882 1.85489 9.82882 1.47852",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37085 9.29151C6.37085 9.91953 6.55693 10.5334 6.90556 11.0556C7.25419 11.5778 7.74971 11.9848 8.32947 12.2251C8.90922 12.4654 9.54716 12.5283 10.1626 12.4058C10.7781 12.2833 11.3434 11.9809 11.7871 11.5368C12.2309 11.0927 12.533 10.5269 12.6555 9.91098C12.7779 9.29504 12.7151 8.65659 12.4749 8.07638C12.2348 7.49617 11.8281 7.00025 11.3064 6.65135C10.7846 6.30244 10.1712 6.11621 9.54363 6.11621C8.70216 6.11621 7.89515 6.45075 7.30014 7.04624C6.70512 7.64172 6.37085 8.44937 6.37085 9.29151Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2172 7.94336L8.90552 10.6397",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78141 7.76649C8.67997 7.67299 8.5471 7.62109 8.40919 7.62109C8.27128 7.62109 8.13841 7.67299 8.03696 7.76649C7.98655 7.81454 7.94642 7.87233 7.919 7.93637C7.89158 8.0004 7.87744 8.06935 7.87744 8.13901C7.87744 8.20868 7.89158 8.27762 7.919 8.34166C7.94642 8.40569 7.98655 8.46349 8.03696 8.51153C8.08267 8.57253 8.14095 8.62298 8.20784 8.65948C8.27473 8.69597 8.34868 8.71766 8.42467 8.72306C8.50066 8.72847 8.57693 8.71746 8.6483 8.6908C8.71968 8.66414 8.7845 8.62245 8.83837 8.56853C8.89224 8.51462 8.93391 8.44975 8.96055 8.37831C8.98719 8.30688 8.99818 8.23056 8.99278 8.1545C8.98738 8.07845 8.96571 8.00445 8.92925 7.9375C8.89278 7.87056 8.84236 7.81224 8.78141 7.76649Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0855 10.0903C11.0375 10.0399 10.9797 9.9997 10.9157 9.97226C10.8518 9.94482 10.7829 9.93066 10.7133 9.93066C10.6436 9.93066 10.5748 9.94482 10.5108 9.97226C10.4468 9.9997 10.389 10.0399 10.341 10.0903C10.2488 10.1889 10.1975 10.3189 10.1975 10.454C10.1975 10.589 10.2488 10.719 10.341 10.8176C10.389 10.8681 10.4468 10.9082 10.5108 10.9357C10.5748 10.9631 10.6436 10.9773 10.7133 10.9773C10.7829 10.9773 10.8518 10.9631 10.9157 10.9357C10.9797 10.9082 11.0375 10.8681 11.0855 10.8176C11.1777 10.719 11.229 10.589 11.229 10.454C11.229 10.3189 11.1777 10.1889 11.0855 10.0903Z",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.e4265bedb65503192cee4736a8a12d5c.svg";
export { ForwardRef as ReactComponent };